import { cssUtil } from "../../utils/cssUtil";
import { getBaseStyles } from "../commonStyles";

const OTP_INPUT_BOX = 4;
export async function renderOtpInputtWidget(context, widget, parent, override = null) {

    const device = widget?.properties?.desktop;
    if (!device) return;

    const wrapper = context.document.createElement("div");
    wrapper.classList.add("widget", "otp_input_widget");
    const breakpoint = context.currentBreakpoint;

    // Styles
    const styles = {
        ...getBaseStyles(widget, breakpoint),
        ...getWrapperStyles()
    };

    wrapper.setAttribute("style", cssUtil.toStyleString(styles));
    wrapper.setAttribute("data-widgetId", widget.uid);
    wrapper.setAttribute("data-widgetType", widget.type);
    wrapper.setAttribute("data-widgetParent", widget.parent);

    for (let i = 0; i < OTP_INPUT_BOX; i++) {
        const input = context.document.createElement("div");
        input.classList.add("otp_input_box");

        const inputStyles = {
            ...applyInputStyles(widget, breakpoint)
        }
        input.setAttribute("style", cssUtil.toStyleString(inputStyles));
        wrapper.appendChild(input);

    }

    parent.appendChild(wrapper);


    return wrapper;
}

function getWrapperStyles() {
    const styles = {};

    styles['display'] = 'flex';
    styles['align-items'] = 'center';
    styles['gap'] = '8px';

    return styles;
}


function applyInputStyles(widget, breakpoint) {
    const styles = {};

    const defaultProperties = widget?.properties?.desktop;
    const deviceProperties = widget?.properties?.[breakpoint];
    const devicePropertiesStyles = deviceProperties?.styles;

    const alignment = devicePropertiesStyles?.layout?.alignment || "left";
    const fieldWidth = devicePropertiesStyles?.layout?.width || 0;
    const fieldHeight = devicePropertiesStyles?.layout?.height || 0;
    const labelPadding = devicePropertiesStyles?.layout?.labelPadding || 0;

    styles['width'] = `${fieldWidth}px`;
    styles['height'] = `${fieldHeight}px`;

    if (alignment === 'left') {
        styles['padding-left'] = `${labelPadding}px`;
    } else if (alignment === 'right') {
        styles['padding-right'] = `${labelPadding}px`;
    }

    const inputStyles = defaultProperties?.styles?.regular?.input;
    const bgStyles = getBgStyles(inputStyles);
    const borderConfig = defaultProperties?.styles?.regular?.border;
    const borderStyles = getBorderStyles(borderConfig);

    return {
        ...styles,
        ...bgStyles,
        ...borderStyles
    };
}


export function getBorderStyles(border) {
    const styles = {};
    if (!border) return styles;

    const {
        radius = {},
        style = 'bottom',
        width = 0,
        color
    } = border;


    if (radius?.topLeft)
        styles['border-top-left-radius'] = `${parseInt(radius.topLeft)}px`;

    if (radius?.topRight)
        styles['border-top-right-radius'] = `${parseInt(radius.topRight)}px`;

    if (radius?.bottomLeft)
        styles['border-bottom-left-radius'] = `${parseInt(radius.bottomLeft)}px`;

    if (radius?.bottomRight)
        styles['border-bottom-right-radius'] = `${parseInt(radius.bottomRight)}px`;


    if (style === 'none') {
        styles['border'] = 'none';
        return styles;
    }

    const borderWidth = `${parseInt(width)}px`;
    const borderColor = color ? getColorsConfig(color) : 'transparent';

    if (style === 'all') {
        styles['border'] = `${borderWidth} solid ${borderColor}`;
    } else if (style === 'bottom') {
        styles['border'] = 'none';
        styles['border-bottom'] = `${borderWidth} solid ${borderColor}`;
    }

    return styles;
}


function getBgStyles(inputStyles) {
    let styles = {};

    if (!inputStyles) {
        return styles;
    }

    const backgroundColorRgb = inputStyles?.background || null;
    if (backgroundColorRgb) {
      styles = {
        ...styles,
        background: getColorsConfig(backgroundColorRgb)
      }
    }

    return styles;
}

function getColorsConfig(color) {
    if (!color) return "inherit";;
    if (color.type === "solid") {
        return cssUtil.getCssColor(color);
    }

    if (color.type === "gradient") {
        return cssUtil.getCssGradient(color);
    }
}